Object.defineProperty(SVGElement.prototype, 'outerHTML', {
  get: function () {
    var $node
    var $temp
    $temp = document.createElement('div')
    $node = this.cloneNode(true)
    $temp.appendChild($node)
    return $temp.innerHTML
  },
  enumerable: false,
  configurable: true
})

Object.defineProperty(window.Node.prototype, 'children', {
  get: function () {
    var i = 0
    var node
    var nodes = this.childNodes
    var children = []

    node = nodes[i]

    while (node) {
      if (node.nodeType === 1) {
        children.push(node)
      }
      node = nodes[i++]
    }
    return children
  }
})



// WEBPACK FOOTER //
// ./src/polyfills.js